const CLOUDINARY_UPLOAD_URL =
  "https://api.cloudinary.com/v1_1/dyeuo3ikh/image/upload";
const CLOUDINARY_UPLOAD_PRESET = "ml_default";

export { CLOUDINARY_UPLOAD_URL, CLOUDINARY_UPLOAD_PRESET };
